import React, {Component} from 'react';

class MachineRadioGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    renderError() {
        if (this.canShowError()) {
            return (
                <div className={'form-control-feedback error-block'}>
                    {this.props.meta.error}
                </div>
            );
        }
        return null;
    }

    canShowError() {
        if (this.props.isUpdate) {
            return this.props.meta.error
        }
        return this.props.meta.error && this.props.meta.touched;
    }

    applyErrorClass() {
        return this.canShowError() ? 'has-danger' : '';
    }

    render() {
        return (
            <div>
                <div className={`form-group row ${this.applyErrorClass()}`}>
                    <label className="col-sm-2 col-form-label"><b>{this.props.label}</b></label>
                    <div className="col-sm-10">
                        {
                            this.props.options.map(option => {
                                return (
                                    <div className="radio" key={option.value}>
                                        <label>
                                            <input
                                                type="radio"
                                                {...this.props.input}
                                                value={option.value}
                                                checked={this.props.input.value === option.value}
                                            /> {option.title}
                                        </label>
                                    </div>
                                );
                            })
                        }
                        {this.renderError()}
                    </div>
                </div>
            </div>
        )
    }
}

export default MachineRadioGroup;



// WEBPACK FOOTER //
// ./web/src/components/machines/MachineRadioGroup.jsx